import { render, staticRenderFns } from "./serviceConnect.vue?vue&type=template&id=e122c8ca"
import script from "./serviceConnect.vue?vue&type=script&lang=js"
export * from "./serviceConnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports